import _ = require('underscore');
import { ServiceLocator } from '../../../app/ServiceLocator';
import { SetOfUsers } from '../../../ts/models/SetOfUsers';
import { ServerUsers } from '../../../ts/resources/ServerUsers';
import { SiteUsers } from '../../../ts/resources/SiteUsers';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { IServerUser } from '../../../ts/ServerApi/types/IServerUser';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { AddUserToSiteActionNotification } from '../../services/notifications/AddUserToSiteActionNotification';
import { ServerAdminUpdateActionNotification } from '../../services/notifications/ServerAdminUpdateActionNotification';
import { AddLocalUsersDialogProps } from '../AddLocalUsersDialog';

export class AddLocalUserToSiteHelperService {
  private $q: ng.IQService = ServiceLocator.get<ng.IQService>('$q');
  private serverUsers: ServerUsers = ServiceLocator.get<ServerUsers>('ServerUsers');
  private siteUsers: SiteUsers = ServiceLocator.get<SiteUsers>('SiteUsers');
  private serverAdminUpdateActionNotification: ServerAdminUpdateActionNotification = ServerAdminUpdateActionNotification.instance;
  private addUserToSiteActionNotification: AddUserToSiteActionNotification = AddUserToSiteActionNotification.instance;

  // section: add user to site
  public addUserToSite(username: string, siteRole: string, props: AddLocalUsersDialogProps, setErrorTextCallback: (errorMsg: string) => void, setBusyState: (busy: boolean) => void) {
    let selectedSiteRole = siteRole === SiteRoles.ServerAdministrator ? SiteRoles.Unlicensed : siteRole;
    let promoteToServerAdmin = siteRole === SiteRoles.ServerAdministrator;

    this.siteUsers.addUsersToSite([username], selectedSiteRole)
      .then((result: any) => {

        this.showNotificationForAddUserToSite(result, username, selectedSiteRole, setErrorTextCallback);

        if (!!result.errors && result.errors.length > 0) {
          setBusyState(false);
        } else {
          const promoteAdminPromise = promoteToServerAdmin ? this.promoteToServerAdmin(username) : this.$q.when({});
          promoteAdminPromise.then((promoteAdminResult: any) => {
            if (!!promoteAdminResult.errors && promoteAdminResult.errors.length > 0) {
              setBusyState(false);
            } else {
              props.close(result);
            }
          });
        }
      });
    }

    public promoteToServerAdmin(username: string): ng.IPromise<any> {
      // TODO: if the backend can give us the IServerUser info (id is all we need) in the IUserNameAvailability result,
      //       we won't have to make this first request to get the Server User.
      let serverUser: IServerUser;
      return this.serverUsers.getUserByUsernameAndDomain(username, 'local')
        .then((user: IServerUser) => {
          serverUser = user;
          return this.serverUsers.updateServerAdminStatus([user.id], true);
        })
        .then((result: IResult) => {
          this.serverAdminUpdateActionNotification.notify(result, SetOfUsers.singletonForUser(serverUser), true);
          return result;
        });
    }

    public showNotificationForAddUserToSite(result: IResult, username: string, siteRole: string, setErrorTextCallback: (errorMsg: string) => void) {
      this.addUserToSiteActionNotification.notify(
        (errorMsg: string) => {
          setErrorTextCallback(errorMsg);
        },
        result,
        username,
        siteRole);
    }
}
